import React, { useMemo } from 'react';

import { SupportedLocales } from '../../lib/api/types';
import formatPrice from '../../lib/ssp/utils/formatPrice';

import { Container } from './styled';

export type PriceProps = {
  currency: string;
  value: string;
  locale: SupportedLocales;
  size?: 'small' | 'big';
};

const Price = ({ currency, value, locale, size = 'small' }: PriceProps) => {
  const formattedValue = useMemo(
    () => formatPrice(locale, currency, value),
    [currency, value, locale],
  );

  return <Container size={size}>{formattedValue}</Container>;
};

export default Price;
